import { Directive } from "@app/components/directive";
import { NgComponent } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { IRootScope } from "@models";

@NgComponent({
    token: Token.KbRipple,
    dependencies: [
        Token.$RootScope
    ]
})
export class KbRipple extends Directive {
    constructor(
        $rootScope: IRootScope
    ) {
        super();

        this.restrict = "A";
        this.scope = false;

        this.link = (scope: ng.IScope, element, atts: any) => {
            let checkbox = scope.$eval(atts.kbRippleCheckbox);
            let $ripple: JQuery;
            let $wave: JQuery;
            let ripples: JQuery[] = [];
            let last: number;
            let duration = 300;
            if (!checkbox) {
                element.addClass("kb-ripple--hover");
            }
            
            let rippleShow = (e: JQueryEventObject) => {
                let rippleDisabled = scope.$eval(atts.kbRippleDisabled) === true;
                if (!rippleDisabled) {
                    if (element.closest("[disabled]").length) {
                        return;
                    }

                    let initPos = element.css("position");
                    let offset = element.offset();
                    let elWidth = element[0].offsetWidth;
                    let elHeight = element[0].offsetHeight;
                    let dia = Math.max(elHeight, elWidth) * 2; // start diameter
                    let x = checkbox ? "50%" : e.pageX - offset.left - (dia / 2) + "px";
                    let y = checkbox ? "50%" : e.pageY - offset.top - (dia / 2) + "px";
                    let scale = checkbox ? 2.88 : 1;
                    $ripple = $('<div/>', {
                        class: "kb-ripple",
                        appendTo: element,
                        css: {
                            overflow: checkbox ? "visible" : "hidden"
                        }
                    });
                    ripples.push($ripple);
                
                    if (!initPos || initPos === "static") {
                        element.css({ position: "relative" });
                    }

                    $wave = $('<div/>', {
                        class: "kb-ripple__wave kb-ripple__wave--enter kb-ripple__wave--visible" + (checkbox ? " kb-ripple__wave--checkbox" : ""),
                        css: {
                            width: checkbox ? "1.2rem" : dia,
                            height: checkbox ? "1.2rem" : dia,
                            transform: `translate(${x}, ${y}) scale3d(0,0,0)`,
                            marginLeft: checkbox ? "-.6rem" : 0,
                            marginTop: checkbox ? "-.6rem" : 0
                        },
                        appendTo: $ripple,
                        // one: {
                        //     animationend: function () {
                        //        $ripple.remove();
                        //     }
                        // }
                    });
                    setTimeout(() => {
                        $wave.removeClass("kb-ripple__wave--enter");
                        $wave.css("transform", `translate(${x}, ${y}) scale3d(${scale}, ${scale}, ${scale})`);
                        last = performance.now();
                    }, 0);
                }
            };

            let rippleHide = () => {
                if (!element || !$ripple || !$wave) return;
                let delay = Math.max(duration - (performance.now() - last), 0);
                setTimeout(() => {
                    $wave.removeClass("kb-ripple__wave--visible");
                    setTimeout(() => {
                        ripples.forEach(r => r.remove());
                    }, duration);
                }, delay);    
            };

            element.on("pointerdown", rippleShow);
            element.on('pointerup', rippleHide)
            element.on('pointerleave', rippleHide)
            element.on('dragstart', rippleHide)


            scope.$on("$destroy", () => {
                element.off();
            });
        };

    }
}